import {Injectable} from '@angular/core';
import {forkJoin, Observable, of, throwError} from "rxjs";
import {ApiService} from "../api/api.service";
import {catchError, delay, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private api: ApiService) {
  }

  getProfile(): Observable<any> {
    const endpoint = 'user/profile';
    return this.api.get(endpoint).pipe(map(data => data['data']));
  }

  getUserMFAPreference(): Observable<any> {
    const endpoint = 'user/mfa-preference';
    return this.api.get(endpoint).pipe(map(data => data['data']));
  }

  updateUserMFAPreference(payload: any): Observable<any> {
    const endpoint = 'user/mfa-preference';
    return this.api.put(endpoint, payload).pipe(map(data => data['data']));
  }

  getProfileImage(avatar: string): Observable<any> {
    const endpoint = 'user/image?avatar=' + avatar;
    return this.api.get(endpoint).pipe(map(data => data['data']));
  }

  updateProfile(profileData: any): Observable<any> {
    const endpoint = 'user/profile';
    return this.api.put(endpoint, profileData).pipe(map(res => res['data']));
  }

  postFile(fileToUpload: File): Observable<any> {
    const endpoint = 'your-destination-url';
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload)

    // TODO Delete this
    return of({'new_avatar': 'https://cdn.icon-icons.com/icons2/21/PNG/256/toons_homer_simpson_homersimpson_2381.png'});

    // TODO Uncomment this
    // return this.api
    //   .post(``, formData, {})
    //   .pipe(map(res => res));
  }

  updateEmail(emails: any): Observable<any> {
    const endpoint = 'user/email';
    return this.api.put(endpoint, emails).pipe(map(res => res['data']));
  }

  deprecatedUpdatePassword(passwords: any): Observable<any> {
    const endpoint = 'user/updatePassword';
    return this.api.put(endpoint, passwords).pipe(map(res => res['data']));
  }

  makeEmailPrimary(email: any): Observable<any> {
    const endpoint = 'user/email/makePrimary';
    return this.api.put(endpoint, email).pipe(map(res => res['data']));
  }

  verifyEmail(email: any): Observable<any> {
    const endpoint = 'user/email/triggerVerification';
    return this.api.put(endpoint, email).pipe(map(res => res['data']));
  }

  /**
   * Trigger mobile number verification (sends SMS code).
   * @param countryCode - Country calling code (e.g., "61")
   * @param phoneNumber - Phone number without country code (e.g., "412345678")
   */
  triggerMobileVerification(countryCode: string, phoneNumber: string): Observable<any> {
    const endpoint = 'user/mobile/triggerVerification';
    return this.api.put(endpoint, { country_code: countryCode, phone_number: phoneNumber }).pipe(map(data => data['data']));
  }

  /**
   * Verify mobile number with OTP code.
   * @param mfaCode - The 6-digit OTP code
   * @param countryCode - Draft country code (required when ent-10313 defer-persist is on)
   * @param phoneNumber - Draft phone number (required when ent-10313 defer-persist is on)
   */
  verifyMobile(mfaCode: string, countryCode?: string, phoneNumber?: string): Observable<any> {
    const endpoint = 'user/mobile/verify';
    const payload: { mfa_code: string; country_code?: string; phone_number?: string } = {
      mfa_code: mfaCode,
    };
    if (countryCode !== undefined && phoneNumber !== undefined) {
      payload.country_code = countryCode;
      payload.phone_number = phoneNumber;
    }
    return this.api.post(endpoint, payload).pipe(map(data => data['data']));
  }

  resetUserMfa(userUid: string): Observable<any> {
    const endpoint = 'user/mfa-reset';
    return this.api.put(endpoint, { reset_method: 'all', user_uid: userUid }).pipe(map(res => res['data']));
  }

  resetAppMfa(): Observable<any> {
    const endpoint = 'user/mfa-reset';
    return this.api.put(endpoint, { reset_method: 'app' }).pipe(map(res => res['data']));
  }

  getMfaAppQrCode(): Observable<any> {
    const endpoint = 'user/mfa-app/request';
    return this.api.put(endpoint, {}).pipe(map(res => res['data']));
  }

  verifyMfaApp(mfaCode: string): Observable<any> {
    const endpoint = 'user/mfa-app/verify';
    return this.api.put(endpoint, { mfa_code: mfaCode }).pipe(map(res => res['data']));
  }

}
